<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    :subtitle="flow.name"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-text-field
      :label="$t('Name')"
      v-model="flow.name"
      :error-messages="nameErrors"
      @input="$v.flow.name.$touch()"
      @blur="$v.flow.name.$touch()"
    ></v-text-field>
    <v-select
      multiple
      v-model="flow.contentTypeIDs"
      :items="contentTypesList"
      item-text="Name"
      item-value="Id"
      v-bind:label="$t('ContentTypes')"
      :error-messages="contentTypeIDsErrors"
      @change="$v.flow.contentTypeIDs.$touch()"
      @blur="$v.flow.contentTypeIDs.$touch()"
    ></v-select>

    <v-select
      v-model="flow.defFieldCode"
      :disabled="flow.id > 0"
      :error-messages="statesFieldErrors"
      @change="$v.flow.defFieldCode.$touch()"
      @blur="$v.flow.defFieldCode.$touch()"
      :items="availableStateFields"
      item-text="Name"
      item-value="Code"
      v-bind:label="$t('Field')"
    ></v-select>
    <v-switch
      v-model="flow.activeNotif"
      :label="$t('EnableAlerts')"
      @change="alertsConfigChanged"
    ></v-switch>
    <v-switch
      :disabled="!flow.activeNotif"
      v-model="flow.notifyByEmail"
      :label="$t('NotifyByEmail')"
    ></v-switch>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import FlowService from "@/services/FlowService";

import Flow from "@/ecm/models/workflow/Flow";
import Utils from "@/ecm/common/Utils";

export default {
  name: "FlowModal",
  created() {
    this.$v.$reset();
  },
  data() {
    return {
      contentTypesList: [],
      modal: {
        title: this.$t("Flow"),
        key: "flowModal",
      },
      open: false,
      flow: new Flow(),
      isNew: true,
    };
  },
  mixins: [validationMixin],
  validations: {
    flow: {
      name: { required },
      contentTypeIDs: { required },
      defFieldCode: { required },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    availableStateFields() {
      var selectedContentTypes = this.contentTypesList.filter((ct) =>
        this.flow.contentTypeIDs.includes(ct.Id)
      );

      var selectedContentTypesFields = selectedContentTypes.flatMap(
        (x) => x.DefFields
      );

      var fieldsInAllContentSelectedContentTypes =
        selectedContentTypesFields.filter((x) =>
          selectedContentTypes.every((ct) =>
            ct.DefFields.some((df) => df.Code == x.Code)
          )
        );

      return fieldsInAllContentSelectedContentTypes;
    },
    modalTitle() {
      return this.modal.title + (this.flow.name ? " - " + this.flow.name : "");
    },
    statesFieldErrors() {
      const errors = [];
      if (!this.$v.flow.defFieldCode.$dirty) return errors;
      !this.$v.flow.defFieldCode.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    contentTypeIDsErrors() {
      const errors = [];
      if (!this.$v.flow.contentTypeIDs.$dirty) return errors;
      !this.$v.flow.contentTypeIDs.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.flow.name.$dirty) return errors;
      !this.$v.flow.name.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    getContentTypes(id) {
      FlowService.getAvailableContentTypes(id).then((data) => {
        this.contentTypesList = data;
      });
    },
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      FlowService.save(this.flow.toDto())
        .then((result) => {
          if (result) {
            if (this.isNew) {
              Utils.toast.success(
                this.$t("Flow") + " " + this.$t("CreatedSuccessfully")
              );
            } else {
              Utils.toast.success(
                this.$t("Flow") + " " + this.$t("UpdatedSuccessfully")
              );
            }
            this.hide();
            this.$emit("on-item-saved");
          }
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    alertsConfigChanged() {
      if (!this.flow.activeNotif) {
        this.flow.notifyByEmail = false;
      }
    },
    new() {
      this.flow = new Flow();
      this.getContentTypes();
      this.$v.$reset();
      this.show();
    },
    edit(dto) {
      this.flow = new Flow(dto);
      this.isNew = false;
      this.getContentTypes(this.flow.id);
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
      this.isNew = true;
    },
  },
};
</script>
